import * as React from 'react';
import toast from 'cogo-toast';
import { Card, Grid, Form, Button } from 'tabler-react';

import { Link } from 'react-router-dom';
import store from '../../shared/store';
import Request from '../../shared/request';
import PageComponent from '../PageComponent';

class Settings extends PageComponent {
  state = {
    isProcessing: false,
  };

  handleSubmit = event => {
    event.preventDefault();
    const { confirmPassword, password } = this.state;
    if (confirmPassword !== password) {
      return toast.warn('两次密码输入不一致');
    }
    this.setPassword({ password });
  };

  async setPassword(data) {
    this.setState({ isProcessing: true });
    const res = await Request.call('setUserPassword', data);
    if (res) {
      this.setState({ password: '', confirmPassword: '' });
      await store.dispatch({ type: 'updateUser' });
      toast.success('密码设置成功');
      window.location.href = '/dashboard/account';
    }
    this.setState({ isProcessing: false });
  }

  render() {
    return (
      <Grid.Row className="miao-setting">
        <Grid.Col>
          <Card>
            <Card.Header>
              <Link to="/dashboard/account">
                <i className="fa fa-angle-left" />
                账号设置
              </Link>
              <Card.Title>设置密码</Card.Title>
            </Card.Header>
            <Form onSubmit={this.handleSubmit}>
              <Form.Input
                onChange={e => this.setState({ password: e.target.value })}
                type="password"
                label="密码"
                autoComplete="off"
                placeholder="Enter Password"
                value={this.state.password}
              />
              <Form.Input
                onChange={e =>
                  this.setState({ confirmPassword: e.target.value })
                }
                type="password"
                label="确认密码"
                autoComplete="off"
                placeholder="Enter Password"
                value={this.state.confirmPassword}
              />
              <Button
                className="miao-setting-btn"
                loading={this.state.isProcessing}
                type="submit"
                color="primary"
                value="Submit">
                设置
              </Button>
            </Form>
          </Card>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

export default Settings;
